import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Button, Spinner } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next"
import { debounce, map, range } from "lodash"

import ToolkitProvider from "react-bootstrap-table2-toolkit"

//actions

import "../../assets/scss/datatables.scss"

import MyPagination from "components/Common/MyPagination"
import DeleteModal from "components/Common/DeleteModal"
import { AvField, AvForm } from "availity-reactstrap-validation"
import moment from "moment"
import TestimonialModal from "./Crud/Modal"
import { deleteTestimonial, getTestimonials } from "store/actions"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { useRole, ROLE_TYPES } from "hooks/useRole"

const Testimonials = () => {
  const { isRole, canManageDelete } = useRole()
  const dispatch = useDispatch()
  const history = useHistory()
  const [page, setPage] = useState(1)
  const [testimonialModal, setTestimonialModal] = useState({
    status: false,
    data: {},
  })
  const [totalItemLimit, setTotalItemLimit] = useState(() => {
    return parseInt(localStorage.getItem("testimonialLimit")) || 10
  })
  const [searchText, setSearchText] = useState("")
  const [imagesPreview, setImagesPreview] = useState([])

  const { loading, Testimonials, total } = useSelector(state => ({
    loading: state.Testimonial.loading,
    Testimonials: state?.Testimonial?.testimonials,
    total: state.Testimonial?.total,
  }))

  const totalPages = Math.ceil(Testimonials?.total / totalItemLimit)
  const pages = range(1, totalPages + 1)
  useEffect(() => {
    dispatch(getTestimonials(page, totalItemLimit, searchText))
  }, [dispatch, page, totalItemLimit, searchText])

  const updatedLocation = {
    ...location,
    state: {
      ...location.state,
      page: 1,
    },
  }

  const [isOpen, setIsOpen] = useState({ status: false, id: "" })

  const handleDelete = id => {
    setIsOpen({ status: true, id: id })
  }

  const handleDeleteEvent = () => {
    setIsOpen({ ...isOpen, status: false })
    dispatch(deleteTestimonial(isOpen?.id))
  }

  const columns = [
    {
      dataField: "no",
      text: "#",
      sort: true,
    },
    {
      dataField: "createdAt",
      text: "Created At",
    },
    {
      dataField: "name",
      text: "User Name",
      sort: true,
    },
    {
      dataField: "message",
      text: "Message",
      sort: true,
    },

    {
      dataField: "action",
      text: "Action",
    },
  ]

  const handleColumns = () => {
    if (isRole(ROLE_TYPES.SALES_MANAGER)) {
      return columns?.filter(i => i.dataField !== "action")
    } else return columns
  }

  const tableData = map(Testimonials?.testimonials, (item, index) => ({
    ...item,
    no: <span>{index + 1 + (page - 1) * totalItemLimit}</span>,
    name: (
      <div style={{ whiteSpace: "break-spaces" }}>
        {item?.name?.slice(0, 110)}
        {item?.name?.length > 110 ? "..." : ""}
      </div>
    ),
    message: (
      <div style={{ whiteSpace: "break-spaces", maxWidth: "300px" }}>
        {item?.message?.slice(0, 200)}
        {item?.message?.length > 200 ? "..." : ""}
      </div>
    ),
    createdAt: moment(item.createdAt).format("DD/MM/YYYY - h:mm a"),
    action: (
      <div>
        <Button
          id={`edit${index}`}
          type="button"
          color="white"
          title="Edit Testimonial"
          className="ms-1 btn"
          onClick={() => setTestimonialModal({ status: true, data: item })}
        >
          <i
            className="bx bx-edit-alt "
            style={{ color: "#ffa500", fontSize: "22px" }}
          />
        </Button>
        {canManageDelete() ? (
          <>
            <Button
              id={`Delete${index}`}
              type="button"
              color="white"
              title="Delete Testimonial"
              className="ms-1 btn "
              onClick={() => {
                handleDelete(item._id)
              }}
            >
              <i
                className="bx bx-trash "
                style={{
                  color: "red",
                  fontSize: "1.3rem",
                }}
              />
            </Button>
          </>
        ) : (
          ""
        )}
      </div>
    ),
  }))

  const debounceClientSearch = debounce(value => {
    setSearchText(value)
    history.push(updatedLocation)
  }, 600)

  const handlePageLimit = e => {
    if (e.target.value >= 1) {
      setTotalItemLimit(parseInt(e.target.value))
      localStorage.setItem("testimonialLimit", e.target.value)
    }
  }

  return (
    <React.Fragment>
      <Row>
        <DeleteModal
          show={isOpen?.status}
          onCloseClick={() => setIsOpen({ ...isOpen, status: false })}
          onDeleteClick={handleDeleteEvent}
        />
        {testimonialModal?.status && (
          <TestimonialModal
            onCloseClick={() => {
              setTestimonialModal({ status: false, data: {} })
              setImagesPreview([])
            }}
            show={testimonialModal?.status}
            updateData={testimonialModal?.data}
            setImagesPreview={setImagesPreview}
            imagesPreview={imagesPreview}
          />
        )}
        <Col className="col-12">
          <Card>
            <CardBody>
              <ToolkitProvider
                keyField="_id"
                key={"id"}
                columns={handleColumns()}
                data={tableData}
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <div className="d-flex align-items-center justify-content-between p-1">
                      {/* <div className="d-flex w-100"> */}
                      <div className="d-flex ">
                        <div className="">
                          <div className="search-box mb-2 d-inline-block w-100">
                            <div className="position-relative mx-0">
                              <AvForm>
                                <AvField
                                  name="searchText"
                                  placeholder="Search"
                                  type="text"
                                  value={searchText}
                                  onChange={e =>
                                    debounceClientSearch(e.target.value)
                                  }
                                />
                              </AvForm>
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>{" "}
                        </div>
                        <div>
                          <AvForm className="form-horizontal mx-2 mb-3 d-flex align-items-center w-75">
                            <div className="mx-1">
                              <span className="">
                                Show
                                <i className="fas fa-sort-numeric-down-alt mx-1"></i>
                              </span>
                            </div>
                            <div className="" style={{ width: "50px" }}>
                              <AvField
                                name="pageLimit"
                                className="form-control"
                                value={totalItemLimit}
                                onChange={e => handlePageLimit(e)}
                                type="text"
                                required
                              />
                            </div>
                          </AvForm>
                        </div>
                      </div>

                      <Button
                        type="button"
                        color="warning"
                        className="btn-rounded  mb-2 me-2 "
                        onClick={() => setTestimonialModal({ status: true })}
                      >
                        <i className="mdi mdi-plus me-1" />
                        New Testimonial
                      </Button>
                    </div>

                    {loading ? (
                      <Spinner color="secondary" className="d-block m-auto" />
                    ) : (
                      <>
                        {Testimonials?.total >= 1 ? (
                          <>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField={"id"}
                                    key={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    // selectRow={selectRow}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    // onTableChange={handleTableChange}
                                    // {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>

                            <MyPagination
                              totalPages={pages}
                              page={page}
                              setPage={setPage}
                            />
                          </>
                        ) : (
                          <p className="my-4 mx-3 ">No Testimonials !</p>
                        )}
                      </>
                    )}
                  </React.Fragment>
                )}
              </ToolkitProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default Testimonials
